var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "3" } }, [
                _c("h1", [_vm._v(_vm._s(_vm.$t("invoice.title")))])
              ]),
              _c("v-spacer"),
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: _vm.$t("global.search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.invoices,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    {},
                    [
                      _vm._v(" " + _vm._s(props.item.number) + " "),
                      props.item.left_to_pay === 0
                        ? _c(
                            "v-chip",
                            {
                              staticStyle: {
                                color: "#44d3af",
                                "background-color":
                                  "rgba(30,255,200,0.22) !important"
                              },
                              attrs: { small: "", label: "", outlined: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("invoice.paid")) + " ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.net_in_currency) +
                        " " +
                        _vm._s(props.item.currency_symbol)
                    )
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "text-left accent--text",
                      staticStyle: { "font-weight": "bold" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(props.item.gross_in_currency) +
                          " " +
                          _vm._s(props.item.currency_symbol) +
                          " "
                      )
                    ]
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.issue_date))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.sale_date))
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "text-left ",
                      staticStyle: { "font-weight": "900" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(props.item.left_to_pay) +
                          " " +
                          _vm._s(props.item.currency_symbol) +
                          " "
                      )
                    ]
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "invoice.paymentType." +
                              props.item.form_of_payment_name.toLowerCase()
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            icon: "",
                                            to:
                                              "/invoices/details/" +
                                              props.item.id
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("invoice.showDetails")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            icon: "",
                                            title: _vm.$t("invoice.download")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadInvoice(
                                                props.item
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("cloud_download")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("invoice.download")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }